import axios from 'axios'

export default defineNuxtPlugin((nuxtApp) => {
    const { $apiFetch } = useNuxtApp()

    function makeRequest(args) {
        return Promise.resolve(
            $apiFetch(...args).then((res) => {
                if (res.toast !== undefined) {
                    nuxtApp.$event.$emit('toast-new-message', res.toast)
                }

                return res
            }),
        )
    }

    nuxtApp.provide('axios', {
        get: (url, data) => {
            return makeRequest([url, data])
        },

        post(url, data, headers) {
            return makeRequest([
                url,
                {
                    body: data,
                    method: 'POST',
                },
                // headers,
            ])
        },

        put(url, data = {}, headers) {
            data._method = 'PUT'

            return makeRequest([
                url,
                {
                    body: data,
                    method: 'POST',
                },
                headers,
            ])
        },

        delete: (url, data = {}, headers) => {
            data._method = 'DELETE'

            return makeRequest([
                url,
                {
                    method: 'POST',
                    body: data,
                },
            ])
        },

        upload: (url = null, formData = null, options = {}) => {
            let headers = nuxtApp.$apiGetFetchHeaders()
            headers['Content-Type'] = 'multipart/form-data'

            options.headers = headers

            console.log(headers)

            return axios.post(nuxtApp.$apiGetConfig().baseUrl + url, formData, options)
        },
    })
})
